import { useMutation, useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

import { QUERY_KEYS } from '.';

const getInitiativeChildData = (id) => {
  const url = endpoints.analytics.initiative.childInitiatives(id);

  return sendRequest({
    method: 'GET',
    url,
    credentials: 'include',
    queryParams: {
      offset: 0,
      limit: 50,
    },
  });
};

export const useInitiativeSubtasksData = ({ id, enabled }) =>
  useQuery(
    [QUERY_KEYS.INITIATIVE_SUBTASKS, id],
    async () => {
      const res = await getInitiativeChildData(id);
      return res.entity;
    },
    { enabled }
  );

const createInitiativeApi = (body) => {
  const url = endpoints.analytics.initiative.index;

  return sendRequest({
    method: 'POST',
    url,
    body: {
      ...body,
    },
    credentials: 'include',
  });
};

export const useCreateNewInitiative = () =>
  useMutation({
    mutationFn: async ({ body }) => createInitiativeApi(body),
  });
